export default __webpack_public_path__ + "static/media/DNo.2-2.0f5fde28.jpg";